hrd.components.form.AbstractTextAreaComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.AbstractTextAreaComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},

	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		var ignoreMaxLengthAttribute = field.data('ignore-maxlength-attr') || false;
		var fnMaxLength = field.data('fn-max-length');
		if (fnMaxLength != undefined && fnMaxLength === true) {
			let fnMLName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-max-length';
			fnMLName = $.functionCase(fnMLName);
			if (this.settings.reference && typeof this.settings.reference[fnMLName] === 'function') {
				field.data('fn-max-length', (field, text) => this.settings.reference[fnMLName].call(this.settings.reference, field, text, this.getFormInstance()));
			} else {
				console.log('Missing maxlength function implementation for "' + fnMLName + '" in "' + this.settings.reference._FULL_ + '". Use "max-length" if available');
			}
		}

		const fnCounter = field.data('fn-counter');
		let fnValueLength = (value) => value.length;

		if (fnCounter != undefined && fnCounter === true) {
			let fnCounterName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-fn-counter';
			fnCounterName = $.functionCase(fnCounterName);
			if (this.settings.reference && typeof this.settings.reference[fnCounterName] === 'function') {
				/* store in data the effective function so that it can be reused by validators */
				let fnImpl = this.settings.reference[fnCounterName].bind(this.settings.reference);
				field.data('fn-lenght-evaluator', fnImpl);
				fnValueLength = (value) => fnImpl(value);
			} else {
				console.log('Missing counter function implementation for "' + fnCounterName + '" in "' + this.settings.reference._FULL_ + '".');
			}
		}

		var maxLength = this.utils().getMaxLength(field);
		if (maxLength) {
			if (!ignoreMaxLengthAttribute) {
				setTimeout(function() {
					/* timeout is needed because of popup dialogs */
					this.field.attr('maxlength', maxLength);
				}.bind({ field: field }), 0);
			}
			var counter = $('<span class="textarea-counter ignore-for-fhs compute-ignore-for-fhs"></span>');
			counter.attr('id', id + '-counter');
			//var counterRowLabel = $('<label></label>').text(xlate('common.form.textarea.counter.label'));
			//var counterRow = $('<div class="field-composite"></div>');
			//counterRow.append(counterRowLabel).append(counter);
			if (field.parent().hasClass('label-on-top')) {
				field.parent().css({
					'position': 'relative',
				});
			} else {
				if(field.usingChromaFlow()) {
					field.parent().css({
						'position': 'relative',
					});
				} else {
					field.parent().css({
						'position': 'relative',
						'margin-top': '20px'
					});
				}
			}
			field.before(counter);
			counter.html(this.utils().createCharCounterMessage(0, maxLength));
			$.timeout(0).then(() => {
				if (field.data('fullHeight') == true) {
					let mbpHeight = field.parent().mbpHeight();
					field.parent().css('height', 'calc(100% - ' + mbpHeight + 'px)');
					field.css('height', 'calc(100% - 10px)');
				}
			});

			field.on('keyup blur', function() {
				var value = this.field.val();
				var maxLength = this.utils().getMaxLength(this.field, value);
				if (!this.ignoreMaxLengthAttribute) {
					this.field.attr('maxlength', maxLength);
				}
				var text_length = fnValueLength(value);
				counter.html(this.utils().createCharCounterMessage(text_length, maxLength)).css('color', (text_length > maxLength) ? 'red' : 'inherit');
			}.bind({ field: field, ignoreMaxLengthAttribute: ignoreMaxLengthAttribute, utils: this.utils.bind(this) }));
		}
		if (field.data('font-size') !== undefined) {
			field.css('font-size', field.data('font-size'));
		}
		if (field.data('placeholder') != undefined) {
			field.attr('placeholder', field.data('placeholder'));
		}

		let taHeigth = dashboardInstance.adaptSize(field.data('height') || '150', {decimalPrecision: 0});
		if(field.usingChromaFlow()) {
			field.css('resize', 'none').outerHeight(taHeigth);
		} else {
			field.css('resize', 'none').height(taHeigth);
		}
	},

	setEditableField: function(field, value, object, options) {
		field.val(value);
		let id = this.getFieldId();
		let maxLength = this.utils().getMaxLength(field, value);
		if (maxLength) {
			var counter = $(`#${id}-counter`);
			counter.html(this.utils().createCharCounterMessage(value.length, maxLength));
		}
	}
});